module.exports = __webpack_public_path__ + "static/media/clientsNormal.3ccfba9e.svg";